import _defineProperty from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { stringify } from 'qs';
import { loadState } from './localStore';
export var TOKEN_KEY = 'token';

var getToken = function getToken() {
  return loadState(TOKEN_KEY) || null;
};

var serialiseParams = function serialiseParams(params) {
  return stringify(params, {
    skipNulls: true
  });
};

export function request(method, domain, directory, params, headers) {
  var serialisedParams = serialiseParams(params);
  var token = getToken(); // note: ternary ensures `undefined` does not get added to end of url

  var searchParams = serialisedParams ? "?".concat(serialisedParams) : '';
  return fetch("".concat(domain).concat(directory).concat(searchParams), {
    method: method,
    headers: token && _objectSpread(_objectSpread({}, headers), {}, {
      Authorization: "Bearer ".concat(token)
    })
  }).then(function (res) {
    if (!res.ok) {
      throw Error(res.statusText);
    }

    return res;
  });
}
export function get(domain, directory, params, headers) {
  return request('GET', domain, directory, params, headers).then(function (res) {
    return res.json();
  });
}
export function mutate(method, domain, directory, data) {
  var token = getToken();
  return fetch("".concat(domain).concat(directory), {
    method: method,
    headers: token && {
      'Content-Type': 'application/json',
      Authorization: "Bearer ".concat(token)
    },
    body: JSON.stringify(data)
  }).then(function (res) {
    if (!res.ok) {
      throw Error(res.statusText);
    }

    return res.json();
  });
}
export function put(domain, directory, data) {
  return mutate('PUT', domain, directory, data);
}
export function patch(domain, directory, data) {
  return mutate('PATCH', domain, directory, data);
}
export function post(domain, directory, data) {
  return mutate('POST', domain, directory, data);
}